<!-- <confirm-user *ngIf="!isConfirmed && isUserRetrieved && !isNoTenantAssigned" [user] = "user" [userTenants] = "userTenants" (onChangeUser)="onChange(user)"></confirm-user> -->
<confirm-user *ngIf="isUserRetrieved && isTenantsRetrieved" [user] = "user" [userTenants] = "userTenants" [showProfile] = true (onChangeUser)="onChange(user)"></confirm-user>

